import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../images/common/kofc.png';

const Header = () => (
  <header className="site-header">
    <Navbar collapseOnSelect expand="lg" className="site-navbar" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="site-brand d-flex align-items-center gap-2">
          <img src={logo} alt="Knights of Columbus Council 1056" className="site-logo" />
          <span className="brand-text">
            <span className="brand-title">Knights of Columbus</span>
            <span className="brand-sub">Council 1056 - St. Mary Parish</span>
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav">
          <Nav className="ms-auto align-items-lg-center gap-lg-1">
            <Nav.Link as={NavLink} to="/" end>
              Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/events">
              Events
            </Nav.Link>
            <NavDropdown title="Membership" id="nav-membership">
              <NavDropdown.Item href="https://kofc1056.square.site/dues">
                Pay Dues
              </NavDropdown.Item>
              <NavDropdown.Item href="https://www.kofc.org/join/" target="_blank" rel="noopener noreferrer">
                Become a Knight
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Donations" id="nav-support">
              <NavDropdown.Item href="https://kofc1056.square.site/charities">
                Donate (Card)
              </NavDropdown.Item>
              <NavDropdown.Item href="https://paypal.me/kofc1056?locale.x=en_US">
                Donate (PayPal)
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={NavLink} to="/calendar" className="nav-calendar">
              Lucky Calendar
            </Nav.Link>
            <NavDropdown title="Other" id="nav-support">
              <NavDropdown.Item as={NavLink} to="/purchasecalendar?type=Knight-Cash">
                Knights Cash
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/purchasecalendar?type=Knight-Event">
                Knights Event
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </header>
);

export default Header;